// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"e0d78f00","796":"a141398b","963":"5aeb5a9c","988":"d8553045"}[chunkId] + ".chunk.js";
};